import ReactGA from 'react-ga4';
import { analytics, Base_url } from '../jsx/services/BaseUrl';

export const initGA = () => {
  ReactGA.initialize(`G-${analytics.gaId}`);
};

export const logPageView = () => {
  ReactGA.send({ hitType: "pageview", page: window.location.pathname });
};
